import React, { useEffect, useState } from 'react';

import Container from "react-bootstrap/Container";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard.css";
import "../styles/main.css";
import "../styles/selectministry.css";
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';

import Dropdown from "react-bootstrap/Dropdown";
import { apiPost } from "../services/api";
import {
  CButton,
 
} from "@coreui/react";

import { Alert, Badge, Form, Spinner } from "react-bootstrap";
 
const ministries = [
  "Ministry of External Affairs",
  "Ministry of Steel",
  "Ministry of Defence",
  "Ministry of Cooperation",
  "Ministry of Finance",
  "Ministry of Tribal Affairs",
  "Ministry of MSME",
  "Ministry of Women and Child Development",
  "Ministry of Panchayati Raj",
  "Ministry of Civil Aviation",
  "Ministry of Jal Shakti",
  "Ministry of Petroleum and Natural Gas",
  "Ministry of Culture",
  "Ministry of Chemicals and Fertilizers",
  "Ministry of Housing and Urban Affairs"
];


const Selectministry = () => {
  const [visibleCards, setVisibleCards] = useState([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleCards(prev => {
        if (prev.length < ministries.length) {
          return [...prev, ministries[prev.length]];
        }
        clearInterval(interval);
        return prev;
      });
    }, 100); // animation delay
    return () => clearInterval(interval);
  }, []);

  return (


     <><Navbar expand="lg" className="bg-body-tertiary">
      <Container className='customflex'>
       
        <Dropdown>
          <div className="userprofilediv">
            <Dropdown.Toggle className="userprofile" id="dropdown-basic">
              <div className="userimg">
                <img src={process.env.PUBLIC_URL + "/anup.jpg"} alt="userimg" />
              </div>
              Anup Soni
            </Dropdown.Toggle>
          </div>
          <Dropdown.Menu>
            <Dropdown.Item href="/">Setting</Dropdown.Item>

            <Dropdown.Item href="/">
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Container>
    </Navbar><>


        <div className="container py-4">
          <div className="row">
            {ministries.map((ministry, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="card shadow-sm h-100">
                  <div className="card-body text-center d-flex flex-column justify-content-between">
                    <h6 className="card-title mb-3">{ministry}</h6>
                    <button className="btn btn-success">Go to dashboard</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div></></>

  );
};

export default Selectministry;